import { useCloseTrainingResets, useMyTrainingResets } from './useMyTrainingResets'

export { useInvalidateMyTrainingResets } from './useMyTrainingResets'
export type { MyTrainingReset } from './useMyTrainingResets'

export const trainingResets = {
  mine: useMyTrainingResets,
  close: useCloseTrainingResets,
}
